import Container from 'react-bootstrap/Container';

const TestimonialsTab = () => {
  return (
    <Container className="py-4">
      <p>Some of the feedback from satisfied recipients of my artwork:</p>

      <p>Bunnies: This is a painting of our bunnies which was a present for my husband. He absolutely loves it! Charlotte researched extensively and was keen to capture both the look and personality of our pets which she has perfectly. I recommend Charlotte without any hesitation.</p>

      <p>Beaulieu Airfield: This was a wedding gift; it&apos;s beautiful and looks stunning in the frame Charlotte chose for it.</p>

      <p>On 'View from Hanham Hill': Charlotte's painting is wonderful - instantly recognisable and makes me want to take to the hills immediately. It has pride of place in my sitting room and I keep going to look at it again.</p>

      <p>On 'Red Coral': Wow! Thank you so much for the painting - it's absolutely amazing. It's perfect and so us!</p>
    </Container>
  );
};

export default TestimonialsTab;

